module.exports = __webpack_public_path__ + "static/media/map-marker-edit.a031a8aa.svg";